import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MatButtonModule } from '@angular/material/button'
import { RouterModule } from '@angular/router'
import {
  IconButtonIconLargeDirective,
  IconButtonIconMediumDirective,
  IconButtonIconOnlyDirective,
  IconButtonIconResponsiveDirective,
  IconButtonIconSmallDirective,
  IconButtonIconXSmallDirective,
  IconButtonMediumDirective,
  IconButtonOutlinedDirective,
  IconButtonResponsiveDirective,
  IconButtonSmallDirective,
  IconButtonUnstyledDirective
} from './icon-button.directive'
import { IconButtonComponent } from './icon-button.component'
import { MatIconModule } from '@angular/material/icon'

@NgModule({
  declarations: [
    IconButtonComponent,
    IconButtonUnstyledDirective,
    IconButtonIconOnlyDirective,
    IconButtonOutlinedDirective,
    IconButtonSmallDirective,
    IconButtonMediumDirective,
    IconButtonResponsiveDirective,
    IconButtonIconXSmallDirective,
    IconButtonIconSmallDirective,
    IconButtonIconMediumDirective,
    IconButtonIconLargeDirective,
    IconButtonIconResponsiveDirective,
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    RouterModule,
  ],
  exports: [
    IconButtonComponent,
    IconButtonUnstyledDirective,
    IconButtonIconOnlyDirective,
    IconButtonOutlinedDirective,
    IconButtonSmallDirective,
    IconButtonMediumDirective,
    IconButtonResponsiveDirective,
    IconButtonIconXSmallDirective,
    IconButtonIconSmallDirective,
    IconButtonIconMediumDirective,
    IconButtonIconLargeDirective,
    IconButtonIconResponsiveDirective,
  ],
})
export class IconButtonModule { }
